import React from "react";

import variables from "../../../styles/_variables.module.scss";

const NoNotification = () => (
  <svg width="320" height="160" viewBox="0 0 320 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="104" y="8" width="168" height="40" rx="4" fill="#F6F6F6" />
    <g opacity="0.25">
      <path
        d="M130.003 24.1609C130.003 22.633 129.396 21.1676 128.315 20.0872C127.235 19.0069 125.769 18.3999 124.242 18.3999C122.714 18.3999 121.248 19.0069 120.168 20.0872C119.088 21.1676 118.481 22.633 118.481 24.1609C118.481 30.882 115.6 32.8023 115.6 32.8023H132.883C132.883 32.8023 130.003 30.882 130.003 24.1609Z"
        stroke="#141516"
        strokeWidth="1.91596"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M125.903 36.6431C125.734 36.9341 125.492 37.1756 125.2 37.3435C124.909 37.5114 124.578 37.5998 124.242 37.5998C123.905 37.5998 123.575 37.5114 123.283 37.3435C122.992 37.1756 122.75 36.9341 122.581 36.6431"
        stroke="#141516"
        strokeWidth="1.91596"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <rect opacity="0.25" x="144" y="18" width="56" height="8" rx="4" fill="#6C5BBE" />
    <rect opacity="0.5" x="144" y="30" width="120" height="8" rx="4" fill="#6C5BBE" />
    <rect x="72" y="56" width="168" height="40" rx="4" fill="#F6F6F6" />
    <g opacity="0.25">
      <path
        d="M98.0025 72.1609C98.0025 70.633 97.3956 69.1676 96.3152 68.0872C95.2348 67.0069 93.7695 66.3999 92.2416 66.3999C90.7137 66.3999 89.2483 67.0069 88.1679 68.0872C87.0875 69.1676 86.4806 70.633 86.4806 72.1609C86.4806 78.882 83.6001 80.8023 83.6001 80.8023H100.883C100.883 80.8023 98.0025 78.882 98.0025 72.1609Z"
        stroke="#141516"
        strokeWidth="1.91596"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.903 84.6431C93.7342 84.9341 93.4919 85.1756 93.2004 85.3435C92.9088 85.5114 92.5783 85.5998 92.2419 85.5998C91.9055 85.5998 91.575 85.5114 91.2834 85.3435C90.9919 85.1756 90.7496 84.9341 90.5808 84.6431"
        stroke="#141516"
        strokeWidth="1.91596"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <rect opacity="0.25" x="112" y="66" width="56" height="8" rx="4" fill="#6C5BBE" />
    <rect opacity="0.5" x="112" y="78" width="120" height="8" rx="4" fill="#6C5BBE" />
    <rect x="40" y="104" width="168" height="40" rx="4" fill="#F6F6F6" />
    <g opacity="0.25">
      <path
        d="M66.0025 120.161C66.0025 118.633 65.3956 117.168 64.3152 116.087C63.2348 115.007 61.7695 114.4 60.2416 114.4C58.7137 114.4 57.2483 115.007 56.1679 116.087C55.0875 117.168 54.4806 118.633 54.4806 120.161C54.4806 126.882 51.6001 128.802 51.6001 128.802H68.883C68.883 128.802 66.0025 126.882 66.0025 120.161Z"
        stroke="#141516"
        strokeWidth="1.91596"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.903 132.643C61.7342 132.934 61.4919 133.176 61.2004 133.344C60.9088 133.511 60.5783 133.6 60.2419 133.6C59.9055 133.6 59.575 133.511 59.2834 133.344C58.9919 133.176 58.7496 132.934 58.5808 132.643"
        stroke="#141516"
        strokeWidth="1.91596"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <rect opacity="0.25" x="80" y="114" width="56" height="8" rx="4" fill="#6C5BBE" />
    <rect opacity="0.5" x="80" y="126" width="120" height="8" rx="4" fill="#6C5BBE" />
    <rect x="192" y="64" width="88" height="88" rx="8" fill="#F6F4FC" />
    <path
      d="M257.333 92L228 121.333L214.667 108"
      stroke={variables["foreground"]}
      strokeWidth="5.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default React.memo(NoNotification);
